module.exports = __webpack_public_path__ + "img/bg-8.b0819225.jpg";